import Buttons from "components/UI/Button/Buttons";
import ModalComponent from "components/UI/MaterialUIComponents/ModalComponent";
import Icon from "Icons/SvgIcons";
import React, { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { eliminar, obtenerDatos } from "services/crudFirebase";
import FormAddOrEditBranchOffice from "./FormAddOrEditBranchOffice";
import parse from "html-react-parser";
import "./BranchOffices.scss";
import { Skeleton } from "@material-ui/lab";
import skeleton from "images/skeletonBranchs.png";
import LazyLoad from "react-lazyload";
import { orderBy } from "natural-orderby";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const BranchOffices = ({ edit = false, setItems, items }) => {
    const history = useHistory();
    const [branchOfficeData, setBranchOfficeData] = useState([]);
    const [stateModal, setStateModal] = useState(false);

    useEffect(() => window.scrollTo(0, 0), []);

    useEffect(() => {
        if (items !== undefined) {
            setBranchOfficeData(itemsOrdered(items));
        }
    }, [items]);

    const itemsOrdered = (items) => {
        return orderBy(items, [(v) => v.ciudad, (v) => v.nombrePlaza], ["asc"]);
    };

    const SkeletonBranchOffice = (
        <>
            <img alt="" className="imgMap" src={skeleton} />
            <Skeleton animation="wave" height={70} variant="text" />
            <Skeleton animation="wave" height={30} variant="text" />
            <Skeleton animation="wave" height={20} width={200} variant="text" />
            <Skeleton animation="wave" height={30} variant="text" />
        </>
    );

    const handleCloseModal = () => setStateModal(false);
    const handleSetBranchOfficeData = (data) => {
        if (edit) {
            setItems(data);
        }
        setBranchOfficeData(itemsOrdered(data));
    };

    useEffect(() => {
        const setData = async () => {
            const data = await obtenerDatos("InfoSucursales");
            handleSetBranchOfficeData(data);
        };
        setData();
        if (edit) {
            if (
                window.localStorage.getItem("account") === "false" ||
                window.localStorage.getItem("account") === false
            ) {
                history.push("/ingresar");
            }
        }
    }, []);

    const onDeleteElement = (id) => {
        const updateData = [...branchOfficeData];
        let returnElements = [];
        updateData.forEach((i) => {
            if (id !== i.id) {
                returnElements = [...returnElements, i];
            }
        });
        handleSetBranchOfficeData(returnElements);
        eliminar(id, "InfoSucursales");
        handleCloseModal();
    };

    return (
        <>
            {!edit && (
                <h2 className="branchOffices__title">
                    ¡Encuentra tu tienda más cercana!
                </h2>
            )}
            <div className="branchOffices">
                {branchOfficeData.length === 0 ? (
                    <>
                        <div className="skeletonBranchOffice">
                            {SkeletonBranchOffice}
                        </div>
                        <div className="skeletonBranchOffice">
                            {SkeletonBranchOffice}
                        </div>
                        <div className="skeletonBranchOffice">
                            {SkeletonBranchOffice}
                        </div>
                        <div className="skeletonBranchOffice">
                            {SkeletonBranchOffice}
                        </div>
                        <div className="skeletonBranchOffice">
                            {SkeletonBranchOffice}
                        </div>
                        <div className="skeletonBranchOffice">
                            {SkeletonBranchOffice}
                        </div>
                    </>
                ) : (
                    branchOfficeData.map((i) => {
                        return (
                            <div key={i.id} className="branchOffices__card">
                                <LazyLoad>
                                    <TransformWrapper>
                                        <TransformComponent
                                            contentStyle={{ display: "grid" }}
                                        >
                                            <img
                                                alt=""
                                                className="imgMap"
                                                src={skeleton}
                                            />
                                            <img
                                                src={i.imgMapa}
                                                alt=""
                                                className="imgMap"
                                            />
                                        </TransformComponent>
                                    </TransformWrapper>
                                </LazyLoad>
                                <h4 className="titleBranchOffice">
                                    {`${i.nombrePlaza} ${i.ciudad} ${i.tipoDeSucursal} ${i.infoLocal}`}
                                </h4>
                                <span className="direction">
                                    {`${i.calle} ${i.numeroExt}${
                                        i.numeroInt !== ""
                                            ? ` Int ${i.numeroInt}`
                                            : ""
                                    }, ${i.colonia}, ${i.codigoPostal}, ${
                                        i.ciudad
                                    }, ${i.estado}`}
                                </span>
                                <span className="telephoneNumber">
                                    <i className="fontIcon--whatsapp" />
                                    <a href={`https://wa.me/52${i.telefono}`}>
                                        {i.telefono}
                                    </a>
                                </span>
                                <span className="workingHours">
                                    {parse(i.horario)}
                                </span>
                                {!edit && (
                                    <div className="card__mapLink">
                                        <a
                                            href={i.linkMaps}
                                            target="_blank"
                                        >
                                            Ver en Google Maps
                                        </a>
                                    </div>
                                )}
                                {edit && (
                                    <>
                                        <div className="groupButtons">
                                            <ModalComponent
                                                stateModal={stateModal}
                                                scrollable={true}
                                                setStateModal={setStateModal}
                                                classNameBtnOpenModal="branchOffice__btn--edit"
                                                slotOpenModal={
                                                    <span title="Editar Producto">
                                                        <Icon
                                                            svg="edit"
                                                            classes="svgIcon--edit"
                                                            title="edit"
                                                        />
                                                    </span>
                                                }
                                            >
                                                <FormAddOrEditBranchOffice
                                                    type="edit"
                                                    setStateModal={
                                                        setStateModal
                                                    }
                                                    item={i}
                                                    items={branchOfficeData}
                                                    setItems={
                                                        handleSetBranchOfficeData
                                                    }
                                                />
                                            </ModalComponent>
                                            <ModalComponent
                                                stateModal={stateModal}
                                                setStateModal={setStateModal}
                                                classNameBtnOpenModal="branchOffice__btn--delete"
                                                slotOpenModal={
                                                    <span title="Eliminar Producto">
                                                        <Icon
                                                            svg="delete"
                                                            classes="svgIcon--delete"
                                                            title="delete"
                                                        />
                                                    </span>
                                                }
                                            >
                                                <div className="modalConfirmDelete">
                                                    <span className="modalConfirmDelete__Span">
                                                        ¿Está seguro que desea
                                                        eliminar esta sucursal
                                                        de forma permanete?
                                                    </span>
                                                    <div className="modalConfirmDelete__groupBtn">
                                                        <Buttons
                                                            className="btnPrimary"
                                                            onClick={() =>
                                                                onDeleteElement(
                                                                    i.id
                                                                )
                                                            }
                                                        >
                                                            Eliminar
                                                        </Buttons>
                                                        <Buttons
                                                            className="groupBtn__btn--cancel btnSecondary"
                                                            onClick={
                                                                handleCloseModal
                                                            }
                                                        >
                                                            Cancelar
                                                        </Buttons>
                                                    </div>
                                                </div>
                                            </ModalComponent>
                                        </div>
                                    </>
                                )}
                            </div>
                        );
                    })
                )}
            </div>
        </>
    );
};

export default BranchOffices;
